import '@commons/polyfills';
import '@commons/reset';
import '@commons/general';
import '@commons/header';
import '@commons/utils';

import ProductFilter from '@vue-instances/ProductFilter';

import '@styles/components/c-product-summary.scss';
import '@styles/components/c-product-filter.scss';
import '@styles/components/c-available-in-modal.scss';

export default function init() {
  ProductFilter();
}

init();
